@use './shared' as *;

$CLASS: '.joy-step';

:host {
    @include hostStyle();

    /**
     * @prop --stepper-text-color: Steps font color
     * @prop --stepper-text-color-ongoing: Ongoing step font color
     * @prop --stepper-text-color-completed: Completed steps font color
     * @prop --stepper-border-color: Default steps border color
     * @prop --stepper-border-color-filled: Filled steps border color
     * @prop --stepper-label-padding-left: Padding left on label
     * @prop --stepper-label-padding-right: Padding right on label
     */
    --stepper-text-color: var(--joy-color-neutral-40);
    --stepper-text-color-ongoing: var(--joy-color-secondary-30);
    --stepper-text-color-completed: var(--joy-color-neutral-60);
    --stepper-border-color: var(--joy-color-neutral-30);
    --stepper-border-color-filled: var(--joy-color-secondary-50);
    --stepper-label-padding-left: var(--joy-core-spacing-10);
    --stepper-label-padding-right: 0;

    @media screen and (max-width: 991px) {
        --stepper-label-padding-left: var(--joy-core-spacing-4);
    }
}

#{$CLASS} {
    display: flex;
    flex-direction: column;
    flex: 1 0;
    text-align: left;
    align-items: flex-start;
    width: 100%;
    position: relative;
    color: var(--stepper-text-color);
    word-break: break-word;
    font-family: var(--joy-font-family);
    font-size: var(--joy-font-size-primary-300);
    font-weight: 700;

    &--size-small {
        font-size: var(--joy-font-size-primary-200);
    }

    &__stroke {
        @include defaultStrokeStyle();

        &--filled {
            @include filledStrokeStyle();
            width: 100%;
        }
    }

    &__label {
        padding-right: var(--stepper-label-padding-right);
        padding-left: var(--stepper-label-padding-left);
    }

    &--ongoing {
        color: var(--stepper-text-color-ongoing);

        .joy-step__stroke {
            &--filled {
                transition: max-width var(--joy-transition-duration-long) var(--joy-transition-timing-function);
            }
        }
    }

    &--completed {
        color: var(--stepper-text-color-completed);
    }
}
